(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-nutram"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const video = document.getElementById('nutramVideo');
    const playBtn = document.getElementById('nutramPlayBtn');
    const playIcon = document.getElementById('nutramPlayIcon');
    const fallback = document.getElementById('nutramVideoFallback');

    if (video && playBtn) {
      // Hide fallback once playback starts
      const hideFallback = () => {
        if (!fallback) return;
        fallback.style.opacity = '0';
        setTimeout(() => fallback && fallback.remove(), 450);
      };

      playBtn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          playIcon.innerHTML = '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>'; // pause icon
        } else {
          video.pause();
          playIcon.innerHTML = '<path d="M8 5v14l11-7z"/>'; // play icon
        }
      });

      // Also hide on the native play event (covers keyboard/OS controls)
      video.addEventListener('play', hideFallback, { once: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-blog-slider"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.nutram-blogs__slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: '.nutram-blogs__nav--next',
      prevEl: '.nutram-blogs__nav--prev',
    },
    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
  });

  } catch(e) { console.error(e); }
})();
})();
